import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petitionFeed',
		path: '/p/:slug/feed',
		component: loadable(async () => import(/* webpackChunkName: "pages/petitionFeed" */ './index'), {
			exportName: 'PetitionFeed',
			fallback: Loading,
		}),
		frame: {
			header: false,
			footer: true,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
